import React, { useEffect } from "react";
import Highcharts, { chart, Series } from 'highcharts'
import HighchartsReact from 'highcharts-react-official';
import HC_exporting from 'highcharts/modules/exporting'
import exportFromJSON from 'export-from-json';
require("highcharts/modules/export-data")(Highcharts);
HC_exporting(Highcharts)

interface DataSeries {
    name: string;
    data: number[];
    events?: {
        afterRender: () => void;
    };
}

const LineChart = (props: any) => {

    let buttons = Highcharts.getOptions().exporting?.buttons?.contextButton?.menuItems?.slice();
    buttons?.push("label");
    useEffect(() => {
        console.log(props)
    }, [])
    const options = {
        chart: {
            zoomType: 'xy',
            backgroundColor: '#f0f0f0',
            colorCount: 15,
        },
        title: { text: 'Aprobación presidencial vs IPC. 2014-2023' },

        xAxis: [{
            categories: props.labels,
            crosshair: true
        }],
        yAxis: [{ // Primary yAxis
            labels: {


            },
            title: {
                text: '% IPC variación anual',

            }
        }, { // Secondary yAxis
            title: {
                text:'% Aprobación presidencial' ,

            },
            labels: {

            },
            opposite: true
        }],
        tooltip: {
            shared: true
        },
        legend: {


        },
        series: props.allData,

        lang: {
            downloadCSV: 'Descargar CSV',
            downloadJPEG: "Descargar JPEG",
            downloadPDF: "Descargar PDF",
            downloadPNG: "Descargar PNG",
            downloadSVG: "Descargar SVG",
            downloadXLS: "Descargar XLS",
            exitFullscreen: "Salir de pantalla completa",
            viewFullscreen: "Ver Pantalla Completa",
            printChart: "Imprimir Gráfico"
        },
        exporting: {
            enabled: props.activeButton,
            menuItemDefinitions: {
                // Custom definition
                label: {
                    onclick: (event: any) => {
                        console.log('clic boton custom');
                        props.exportExcel({ titulo: props.title, id: props.idChart });
                    },
                    text: 'Descargar XLSX'
                }
            },

            buttons: {
                contextButton: {
                    menuItems: [
                        "viewFullscreen",
                        "printChart",
                        "separator",
                        "downloadPNG",
                        "downloadJPEG",
                        "downloadPDF",
                        "downloadSVG",
                        "separator",
                        "label"
                    ]
                }
            }
        },
        credits: {
            enabled: false
        }
    }

    return (
        <>
            <HighchartsReact highcharts={Highcharts} options={options} />
        </>
    )
}

export default LineChart